export default __webpack_public_path__ + "static/media/hero-img-01.fe3e549d.png";